import React, { lazy, Suspense, useEffect } from "react";
import { connect } from 'react-redux';
import { createFetch } from "../../../../../../helpers/fetch/FetchRequest";
import { updateInstanceData, updateBodyServer } from "../../../../../../redux/actions/DeploymentActions";
import { handleRegionFlag, handleRegionZones } from "./regionDataHelper";
import ImgCDN from "../../../../../../components/ImgCDN";
import Loading from "../../../../../../components/Loading";
import { removeLastModalLayer, wipeModalState } from "../../../../../../redux/actions/ModalActions";

const Regions = lazy(() => import('./components/Regions'));
import styles from './Datacenter.module.scss'
import showModalDefault from "../../../../../../helpers/ui/ModalDefault";
import InstanceLayout from "../../layouts/InstanceLayout";
import { API_APP_INTERNAL } from "../../../../../../settings/endpoints/app";

function Datacenter({instanceData, bodyServer, currentCloud, dispatch}) {

    useEffect(() => {
        if (!!currentCloud?.config?.regionsFetch) {
            dispatch(updateInstanceData({regionsStatus: 'loading'}));
            createFetch({
                URL: '/api/instance',
                requestTitle: 'Regions',
                method: 'POST',
                body: {
                    url: !!currentCloud.config.regionsURL ? currentCloud.config.regionsURL : `${API_APP_INTERNAL}/${currentCloud['code']}/regions`,
                },
                onSuccess: response => {
                    // handle regions
                    let handledRegions = [];
                    response.regions.map(region => {
                        handledRegions.push({
                            ...region,
                            ...{flag: handleRegionFlag(region, currentCloud, response.regions)},
                            ...{zones: handleRegionZones(region)},
                        })
                    });
                    dispatch(updateInstanceData({regionsStatus: 'success', regions: handledRegions}));
                },
                onError: response => {
                    dispatch(updateInstanceData({regionsStatus: 'error'}));
                }
            })
        }
    }, []);

    useEffect(() => {
        if (!!currentCloud?.config?.regionsFetch && instanceData.regionsStatus === 'success') {
            const firstRegion = instanceData.regions[0];
            const setDefaultRegionAndZone = () => {
                dispatch(updateBodyServer({region: firstRegion.id}));
                if (!!firstRegion['zones'] && !!firstRegion.zones.length) {
                    dispatch(updateBodyServer({zone: firstRegion.zones[0]}));
                }
            }

            if (!!bodyServer.region) {
                // check and set if required redeploy data
                const foundRegion = instanceData.regions.find(r => r.id === bodyServer.region);
                // if selected region do nat support previously selected zone, select a new one
                if (
                    !!bodyServer.zone
                    && !!foundRegion && !!foundRegion.zones && !!foundRegion.zones.length
                    && !foundRegion.zones.some(z => z === bodyServer.zone)
                ) {
                    dispatch(updateBodyServer({zone: foundRegion.zones[0]}));
                }
                // if redeploy region is no longer supported, set the first one from data
                if (!foundRegion) setDefaultRegionAndZone();
            } else {
                setDefaultRegionAndZone();
            }
        }
    }, [instanceData.regionsStatus]);

    const selectedRegion = !!instanceData.regions && !!bodyServer.region && instanceData.regions.find(r => r.id === bodyServer.region);

    if (!currentCloud.config || instanceData.regionsStatus !== 'success' || !selectedRegion) return (
        <div className={styles['datacenter']} id='datacenter-anchor'>
            <div className={styles['layout']}>
                <Loading type='component-cover'/>
            </div>
        </div>
    )

    const disabled = false;  // @todo after images are done

    return (
        <InstanceLayout
            title='Datacenter'
            id='datacenter-anchor'
            disabled={disabled}
            onClick={() => {
                showModalDefault({
                    component: (
                        <Suspense fallback={<Loading/>}>
                            <Regions
                                regions={instanceData.regions}
                                selectDatacenter={region => {
                                    dispatch(updateBodyServer({region: region}));
                                    dispatch(removeLastModalLayer());
                                }}
                                selectZone={(region, zone) => {
                                    dispatch(updateBodyServer({
                                        region: region,
                                        zone: zone
                                    }));
                                    dispatch(wipeModalState());
                                }}
                                disabled={disabled} // @todo
                            />
                        </Suspense>
                    ),
                    maxWidth: 'calc(920px + 40px)',
                    title: 'Select datacenter',
                })
            }}
        >
            <div className={styles.layout}>
                <div className={styles.layout__flag}>
                    <ImgCDN
                        className={styles.layout__flag__image}
                        src={selectedRegion.flag.src}
                        alt={selectedRegion.flag.alt}
                        fallbackImage={'/img/flags/no-flag.svg'}
                        loadingRender={<Loading type='component-cover'/>}
                        testImage
                    />
                </div>
                <div className={styles.layout__region}>
                    <p className={styles.layout__region__name}>
                        {selectedRegion.description || selectedRegion.name}
                    </p>
                    <p className={styles.layout__region__zone}>
                        {!!selectedRegion.zones && !!selectedRegion.zones.length ? `Zone "${bodyServer.zone}"` : 'Common zone'}
                    </p>
                </div>
            </div>
        </InstanceLayout>
    )
}

const mapStateToProps = state => ({
    currentCloud: state.deployment.currentCloud,
    instanceData: state.deployment.instanceData,
    bodyServer: state.deployment.bodyServer,
});

export default connect(mapStateToProps)(Datacenter)